import { APIContext, fetcher } from "@certn/api";
import { useAuth } from "@certn/auth";
import { useContext } from "react";
import useSWR from "swr";

import constants from "../../constants";

/**
 * Makes an API request to all regions.
 *
 * Making an API request to a region creates the user in that region and triggers immediate Auth0 sync.
 * This prevents cases where a credential request is sent to a region before the user is created in that region.
 */
export function useCreateUserInAllRegions() {
  const auth = useAuth();
  const api = useContext(APIContext);

  const domains = Object.keys(constants)
    .filter((key) => key.startsWith("VITE_DOMAIN_"))
    .map((key) => constants[key]);

  return useSWR(auth.user ? "create-user-in-all-regions" : null, async () => {
    const requests = domains
      .filter((domain) => domain !== api.domain)
      .map((domain) =>
        fetcher.request("/api/internal/applicant/me/", {}, domain)
      );
    return await Promise.allSettled(requests);
  });
}
